import { useTheme } from '@emotion/react'
import BreadcrumbHeader from 'layout/BreadcrumbsHeader'
import React, { useRef } from 'react'
import ThemeBGWrapper from 'ui-components/ThemeBGWrapper'
import { handleFormSubmit, currencyAllowNegativeInputProps, amountInWords, formatAllowsNegativeCurrency, formatAllowsNegativeDecimal, hasFormChanges } from 'utils/index'
import { FieldArray, Form, FormikProvider, useFormik } from 'formik'
import { Box, CircularProgress, Divider, Grid, Tooltip, Typography } from '@mui/material'
import * as Yup from "yup";
import CustomInputField from 'ui-components/formik/CustomInputField'
import { useNavigate } from 'react-router-dom'
import CustomDatePicker from 'ui-components/formik/CustomDatePicker'
import moment from 'moment'
import { FetchSavedConfigurationTemplates, SaveMetricPerformanceData } from 'api/org/performance'
import { useSelector } from 'react-redux'
import toast from 'react-hot-toast'
import Cookies from 'js-cookie'
import { FetchSavedMetricDataByID } from 'api/org/performance'
import toast_message from "utils/toast_message.json"
import { useToast } from 'context/ToastContext'
import UnsavedChangesPopup from 'ui-components/popups/UnsavedChangesPopup'
import { Primary, Secondary } from 'ui-components/Buttons';

const EditPerformance = () => {
    const theme = useTheme()
    const { addToast } = useToast();
    const navigate = useNavigate()
    const metric_id = Cookies.get("metric_id") || null;
    const isEditMode = !!metric_id;
    let [startup_id, setStartupID] = React.useState(Cookies.get("startup_id") || null);
    const { data: savedConfigurationData, isLoading: isLoadingSavedConfigurationData, refetch: refetchSavedConfigurationData } = FetchSavedConfigurationTemplates(startup_id);
    const { data: savedMetricDataByID, isLoading: isLoadingSavedMetricDataByID, refetch: refetchSavedMetricDataByID } = FetchSavedMetricDataByID({ metric_id });

    const savedValues = {
        month: savedMetricDataByID?.month,
        // chart_values: Object.keys(savedMetricDataByID?.data)

        // ...savedMetricDataByID
        // chart_values: [
        //     { label: "Monthly Revenue", value: "", unit: "INR" },
        //     { label: "Burn Rate", value: "", unit: "INR" },
        //     { label: "Runway", value: "", unit: "months" },
        // ]


        chart_values: savedConfigurationData ? savedConfigurationData?.data?.map((item, index) => {
            return (
                {
                    ...item,
                    keyIndex: index,
                    label: item?.key,
                    value: savedMetricDataByID?.data[item?.keySlug],
                }
            )
        }) : []
    }

    // console.log(savedValues, "savedMetricDataByID")

    const {
        mutateAsync: saveMetricAsync,
        isLoading: isSavingMetric,
        status: saveMetricStatus,
        error: saveMetricError,
        data: saveMetricResponse
    } = SaveMetricPerformanceData();
    const bottomElement = useRef(null);

    const validationObj = {
        month: Yup.string().required("Month is required"),
        chart_values: Yup.array().of(Yup.object().shape(
            { label: Yup.string().required("Key is required"), value: Yup.string().required("Value is required") },
        )),
    }

    const validationSchema = Yup.object({ ...validationObj });

    const initialValues = {
        month: "",
        // chart_values: [
        //     { label: "Monthly Revenue", value: "", unit: "INR" },
        //     { label: "Burn Rate", value: "", unit: "INR" },
        //     { label: "Runway", value: "", unit: "months" },
        // ]

        chart_values: savedConfigurationData ? savedConfigurationData?.data?.map((item, index) => {
            return (
                {
                    ...item,
                    keyIndex: index,
                    label: item?.key,
                    value: "",
                }
            )
        }) : []
    }



    const formik = useFormik({
        initialValues: isEditMode && !isLoadingSavedMetricDataByID && !isLoadingSavedConfigurationData ? savedValues : initialValues,
        validationSchema: validationSchema,
        enableReinitialize: true,
        validateOnChange: false,
        validateOnBlur: false,
        validateOnMount: false,
        onSubmit: (values) => {

            // const setDayToFirstAndIncrementMonth = (isoDate) => {
            //     // Parse the ISO date string
            //     const date = new Date(isoDate);

            //     // Increment the month
            //     const currentMonth = date.getMonth(); // Months are 0-indexed (0 = January, 11 = December)
            //     // date.setMonth(currentMonth + 1);

            //     // Set the day to 1
            //     date.setDate(1);

            //     // Convert back to ISO format
            //     return date.toISOString();
            // };

            // Example usage
            //   const originalDate = "2024-03-31T18:30:00.000Z";
            //   const updatedDate = setDayToFirstAndIncrementMonth(originalDate);

            //   console.log(updatedDate); // Output: "2024-04-01T18:30:00.000Z"


            // let formattedDate = moment(new Date(values?.month).setUTCDate(2))?.toISOString();
            // let formattedDate = setDayToFirstAndIncrementMonth(values?.month);
            // console.log(formattedDate, values?.month,"month")

            // console.log(values?.month,"values?.month")


            // const savedData = {
            //     key_metrics: selectedValues?.key_metrics,
            // }

            // console.log("savedData", formattedDate)

            const payload = {
                "startup_id": startup_id,
                // "month": formattedDate,
                "month": values?.month,
                "data":
                    values?.chart_values?.length ? values?.chart_values?.reduce((acc, item) => {
                        acc[item.keySlug] = Number(String(item.value)?.replaceAll(",", "")) || 0;
                        return acc;
                    }, {}) : {}
            }

            if (isEditMode) {
                payload.metrics_id = metric_id;
            }
            saveMetricAsync({ payload, isEditMode }, {
                onSuccess: (apiResponse) => {
                    if (apiResponse?.data?.statusCode === 200) {
                        // console.log("Success")
                        addToast((isEditMode ? toast_message?.performance?.edit : toast_message?.performance?.add), "success")
                        // toast.success(isEditMode ? toast_message?.performance?.edit : toast_message?.performance?.add)
                        // if (isEditMode) {
                        navigate(-1)
                        // }
                        // else {
                        //     formik.setValues(initialValues);
                        // }
                        // console.log(apiResponse,'apiResponse')
                    }
                    else {
                        // console.log("Error")
                        // toast.error(apiResponse?.data?.message)
                        addToast(apiResponse?.data?.message, "error")
                        // console.log(apiResponse,'apiResponse')
                    }


                },
                onError: () => {

                    // console.log("Error")
                }
            })

        },
    });


    // console.log(formik.values)

    const handleSubmit = (e) => {
        handleFormSubmit(e, formik)
    };

    const scrollToBottom = () => {

        // Find the first visible validation message
        setTimeout(() => {
            if (bottomElement && bottomElement.current && bottomElement.current.offsetParent !== null) {
                bottomElement.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }, 10)
    }


    const groupedData = !isLoadingSavedConfigurationData ? formik.values?.chart_values?.reduce((acc, item) => {
        acc[item.categoryName] = acc[item.categoryName] || [];
        acc[item.categoryName].push(item);
        return acc;
    }, {}) : {};

    const [hasUnsavedChanges, setHasUnsavedChanges] = React.useState(false);

    const handleDiscardChanges = () => {
        navigate(-1);
    }

    const handleCloseUnsaved = () => {
        setHasUnsavedChanges(false)
    }

    // console.log(groupedData, "chart_values")

    return (
        <>
            <UnsavedChangesPopup open={hasUnsavedChanges} handleClose={handleCloseUnsaved} handleSubmission={handleDiscardChanges} key={"Update Profile"} />
            <ThemeBGWrapper>
                <BreadcrumbHeader title={isEditMode ? "Edit" : "Add"} breadcrumbTitle={Cookies.get("selected_startup_name") + ` (Performance)`} customBackgroundColor={theme.palette.customColors.indigo25} />
                {/* <PerfectScrollbar
                    containerRef={containerRef}
                    style={{ height: "calc(100vh - 120px)" }}> */}
                {
                    isLoadingSavedConfigurationData || (isEditMode && (isLoadingSavedMetricDataByID) || !Array.isArray(formik?.values?.chart_values) || formik?.values?.chart_values?.length <= 0)
                        ?
                        <Grid item xs={12} height={"100vh"} sx={{ width: '100%', padding: "2rem", paddingLeft: "2rem !important", paddingTop: "0rem !important", bgColor: theme.palette.customColors.yellow_bg }} paddingInline={{ xs: "0.5rem !important", sm: '1rem !important', md: '1rem !important', lg: '2rem !important' }}>
                            <Box className='skeleton' minHeight={"70vh"} sx={{ borderRadius: "8px", border: `1px solid ${theme.palette.customColors.b50}` }} marginTop={0}>

                            </Box>
                            <Grid item
                                container
                                display={"flex"}
                                xs={12}
                                sm={12}
                                height={"min-content"}
                                gap={"1.5rem"}
                                justifyContent={"center"}
                                padding={{ xs: "0 0rem 1rem 0rem", md: "0 0rem 0rem 0rem" }} sx={{ marginTop: "1rem" }}>
                                <Grid xs={5} sm={5} md={4} lg={3} item>
                                    <Secondary className='skeleton' fullWidth sx={{
                                        // bgcolor: theme.palette.customColors.indigo600,
                                        // border: `1px solid ${theme.palette.customColors.gray300}`,
                                        // padding: '10px 16px',
                                        fontWeight: 600,
                                        // minWidth: isSmallScreen ? "0" : '64px',
                                        height: '50px',
                                        width: '100%',
                                        color: 'transparent',
                                        textTransform: "none",
                                        padding: 2,
                                        borderWidth: 0,
                                        borderRadius: "8px",
                                    }}>Reset</Secondary>
                                </Grid>
                                <Grid xs={5} sm={5} md={4} lg={3} item>
                                    <Primary className='skeleton' fullWidth sx={{
                                        // bgcolor: theme.palette.customColors.indigo600,
                                        // border: `1px solid ${theme.palette.customColors.gray300}`,
                                        padding: '10px 16px',
                                        fontWeight: 600,
                                        // minWidth: isSmallScreen ? "0" : '64px',
                                        height: '50px',
                                        width: '100%',
                                        color: 'transparent'

                                    }}>Submit</Primary>
                                </Grid>
                            </Grid>
                        </Grid>
                        :
                        <Grid container xs={12} padding={{ xs: "0 0rem 1rem 2rem", md: "0 1rem 2rem 3rem" }} spacing={2} justifyContent={"space-between"} height={"calc(100% - 10rem)"}>
                            <FormikProvider value={formik}>
                                <Form
                                    onSubmit={(event) => event.preventDefault()}
                                    style={{ width: "100%", height: "100%", paddingBottom: '0rem' }}
                                >
                                    <Box
                                        style={{
                                            width: "100%",
                                            paddingRight: "1rem",
                                            paddingTop: "1rem",
                                            // marginTop: 20,
                                            paddingBottom: { xs: "1rem", md: 0 },
                                            minHeight: '55vh',
                                            // maxHeight: '65vh',
                                            // overflow: 'hidden auto',
                                        }}
                                    // className="scrollbar-container"
                                    // id="scrollable-form-round"
                                    >
                                        <Grid
                                            item
                                            container
                                            xs={12}
                                            paddingBottom={{ xs: 2, md: 0 }}
                                            justifyContent={"space-between"}
                                            columnSpacing={"0.5rem"}
                                        >
                                            <Grid item xs={12} container rowGap={2}>
                                                <Grid
                                                    xs={12}
                                                    item
                                                    container
                                                    sx={{
                                                        background:
                                                            theme.palette.customColors.whiteBG,
                                                        position: 'relative'
                                                    }}
                                                    border={`1px solid ${theme.palette.customColors.g75}`}
                                                    padding={"0.8rem 1rem 1rem 1rem"}
                                                    borderRadius={"8px"}
                                                    gap={2}
                                                >
                                                    <Grid
                                                        item
                                                        container
                                                        xs={12}
                                                        sm={12}
                                                        spacing={2}
                                                        // row
                                                        height={"min-content"}
                                                        position={"relative"}
                                                    >
                                                        <Grid
                                                            item
                                                            xs={12}
                                                            md={6}
                                                            lg={4}
                                                            xl={3}
                                                        >
                                                            <CustomDatePicker
                                                                fullWidth={false}
                                                                name={`month`}
                                                                // disabled={isEditMode}
                                                                value={moment(formik.values.month)}
                                                                label={"SELECT MONTH"}
                                                                sx={{
                                                                    background: "#fff",
                                                                    borderColor: 'rgba(0, 0, 0, 0.23)',
                                                                    borderRadius: '4px',
                                                                    margin: 0,
                                                                    width: "100%",
                                                                }}
                                                                slotProps={{
                                                                    input: {
                                                                        placeholder: 'Enter month'
                                                                    }
                                                                }}
                                                                format={"MMM YYYY"}
                                                                openTo={"month"}
                                                                views={['year', 'month']}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Divider />
                                                    </Grid>
                                                    <FieldArray
                                                        name={'chart_values'}
                                                        render={(helpers) => (
                                                            <>
                                                                <Grid
                                                                    item
                                                                    container
                                                                    xs={12}
                                                                    sm={12}
                                                                    height={"min-content"}
                                                                    // gap={"0.5rem"}
                                                                    spacing={2}

                                                                // paddingTop={"0rem !important"}
                                                                >
                                                                    <Grid
                                                                        item
                                                                        container
                                                                        xs={12}
                                                                        // height={"min-content"}
                                                                        maxHeight={{ xs: "calc(100vh - 16.875rem)", sm: "calc(100vh - 16.875rem)" }}
                                                                        className="scrollbar-container"
                                                                        id="scrollable-form-round"
                                                                        overflow={"auto"}
                                                                        // gap={"0.5rem"}
                                                                        spacing={2}
                                                                        sx={{ marginTop: '1rem', paddingBottom: "0.5rem" }}

                                                                        paddingTop={"0rem !important"}
                                                                    >
                                                                        {
                                                                            Object.keys(groupedData)?.map((currentCategory, index) => {
                                                                                return <>
                                                                                    <Grid
                                                                                        item
                                                                                        xs={12} paddingTop={"0rem !important"} marginTop={index === 0 ? "0rem" : "1rem"} paddingBottom={{ xs: "1rem", sm: "0rem" }} sx={{ position: 'sticky', top: 0, bgcolor: "white", zIndex: 1 }}>
                                                                                        <Typography fontWeight={700} fontSize={"1.25rem"} variant='body1'>
                                                                                            {currentCategory}
                                                                                        </Typography>
                                                                                    </Grid>
                                                                                    {
                                                                                        groupedData[currentCategory]?.map(
                                                                                            (currentProperty, idx) => {
                                                                                                {/* console.log(idx,"idx") */ }
                                                                                                return (
                                                                                                    <>
                                                                                                        <Grid
                                                                                                            item
                                                                                                            container
                                                                                                            xs={12}
                                                                                                            sm={6}
                                                                                                            md={3}
                                                                                                            // xs={2.945}
                                                                                                            display={"flex"}
                                                                                                            // spacing={1}
                                                                                                            // spacing={"0.5rem"}
                                                                                                            height={
                                                                                                                "min-content"
                                                                                                            }
                                                                                                            paddingTop={{ xs: idx === 0 ? "0rem !important" : "inherit", sm: "1rem !important" }}

                                                                                                        >

                                                                                                            <Grid
                                                                                                                item
                                                                                                                container
                                                                                                                xs={12}
                                                                                                                // sm={6}
                                                                                                                // lg={6}
                                                                                                                display={"flex"}
                                                                                                                flexWrap={"nowrap"}
                                                                                                                height={
                                                                                                                    "min-content"
                                                                                                                }
                                                                                                            >
                                                                                                                <Tooltip title={amountInWords(currentProperty?.value, currentProperty?.unit == "INR" ? "₹" : "$")}>
                                                                                                                    {
                                                                                                                        (currentProperty?.unit == "INR" || currentProperty?.unit == "USD") ?
                                                                                                                            <CustomInputField
                                                                                                                                label={currentProperty?.label}
                                                                                                                                InputProps={{
                                                                                                                                    ...currencyAllowNegativeInputProps,
                                                                                                                                    startAdornment: (
                                                                                                                                        <Box sx={{ padding: "0 0 0 1rem" }}>
                                                                                                                                            {currentProperty?.unit == "INR" ? "₹" : "$"}
                                                                                                                                        </Box>
                                                                                                                                    ),
                                                                                                                                }}
                                                                                                                                sx={{
                                                                                                                                    borderRadius:
                                                                                                                                        "4px",
                                                                                                                                    marginBottom: 0,
                                                                                                                                    width: "100%"
                                                                                                                                }}
                                                                                                                                name={`chart_values.${currentProperty?.keyIndex}.value`}
                                                                                                                                value={
                                                                                                                                    formatAllowsNegativeCurrency(currentProperty?.value, currentProperty?.unit == "INR" ? "en-IN" : "en-US")?.replaceAll("--", "")
                                                                                                                                }
                                                                                                                                placeholder={
                                                                                                                                    "Enter value"
                                                                                                                                }
                                                                                                                                onChange={(e) =>
                                                                                                                                    formik.setFieldValue(
                                                                                                                                        `chart_values.${currentProperty?.keyIndex}.value`,
                                                                                                                                        formatAllowsNegativeCurrency(e.target.value, currentProperty?.unit == "INR" ? "en-IN" : "en-US")?.replaceAll("--", "")

                                                                                                                                    )
                                                                                                                                }
                                                                                                                                fullWidth={true}
                                                                                                                            />

                                                                                                                            :

                                                                                                                            currentProperty?.unit == "Percentage" ? <CustomInputField
                                                                                                                                sx={{
                                                                                                                                    borderRadius:
                                                                                                                                        "4px",
                                                                                                                                    marginBottom: 0,
                                                                                                                                    width: "100%"
                                                                                                                                }}
                                                                                                                                InputProps={{
                                                                                                                                    ...currencyAllowNegativeInputProps,
                                                                                                                                    endAdornment: (
                                                                                                                                        <Box sx={{ padding: "0 1rem 0 0rem" }}>
                                                                                                                                            %
                                                                                                                                        </Box>
                                                                                                                                    ),
                                                                                                                                }}
                                                                                                                                name={`chart_values.${currentProperty?.keyIndex}.value`}
                                                                                                                                value={
                                                                                                                                    formatAllowsNegativeDecimal(currentProperty?.value)?.replaceAll("--", "")
                                                                                                                                }
                                                                                                                                placeholder={
                                                                                                                                    "Enter value"
                                                                                                                                }
                                                                                                                                label={currentProperty?.label}
                                                                                                                                onChange={(e) =>
                                                                                                                                    formik.setFieldValue(
                                                                                                                                        `chart_values.${currentProperty?.keyIndex}.value`,
                                                                                                                                        formatAllowsNegativeDecimal(e.target.value)?.replaceAll("--", "")
                                                                                                                                        //     ?.charAt(
                                                                                                                                        //         0
                                                                                                                                        //     )
                                                                                                                                        //     ?.toUpperCase() +
                                                                                                                                        // e.target.value?.slice(
                                                                                                                                        //     1
                                                                                                                                        // )
                                                                                                                                    )
                                                                                                                                }
                                                                                                                                fullWidth={true}
                                                                                                                            /> :
                                                                                                                                <CustomInputField
                                                                                                                                    sx={{
                                                                                                                                        borderRadius:
                                                                                                                                            "4px",
                                                                                                                                        marginBottom: 0,
                                                                                                                                        width: "100%"
                                                                                                                                    }}
                                                                                                                                    name={`chart_values.${currentProperty?.keyIndex}.value`}
                                                                                                                                    value={
                                                                                                                                        currentProperty?.value
                                                                                                                                    }
                                                                                                                                    placeholder={
                                                                                                                                        "Enter value"
                                                                                                                                    }
                                                                                                                                    label={currentProperty?.label}
                                                                                                                                    onChange={(e) =>
                                                                                                                                        formik.setFieldValue(
                                                                                                                                            `chart_values.${currentProperty?.keyIndex}.value`,
                                                                                                                                            e.target.value
                                                                                                                                            // formatAllowsNegativeCurrency(e.target.value, currentProperty?.unit == "INR" ? "en-IN" : "en-US")
                                                                                                                                        )
                                                                                                                                    }
                                                                                                                                    fullWidth={true}
                                                                                                                                />
                                                                                                                    }
                                                                                                                </Tooltip>
                                                                                                            </Grid>
                                                                                                        </Grid>
                                                                                                    </>
                                                                                                );
                                                                                            }
                                                                                        )
                                                                                    }
                                                                                    {
                                                                                        index != Object.keys(groupedData)?.length - 1 && <Grid item xs={12}>
                                                                                            <Divider />
                                                                                        </Grid>
                                                                                    }
                                                                                </>
                                                                            })
                                                                        }
                                                                    </Grid>
                                                                </Grid>
                                                            </>
                                                        )}
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Box component={"p"} ref={bottomElement} sx={{ opacity: 0, position: "relative", width: '100%', height: "1px" }}>

                                            </Box>
                                        </Grid>
                                    </Box>
                                </Form>
                            </FormikProvider>
                            <Grid
                                item
                                container
                                display={"flex"}
                                xs={12}
                                sm={12}
                                height={"min-content"}
                                gap={"1.5rem"}
                                justifyContent={"center"}
                                padding={{ xs: "0 0rem 1rem 0rem", md: "0 0rem 0rem 0rem" }}
                            >
                                <Grid xs={5} sm={5} md={4} lg={3} item>
                                    <Secondary
                                        sx={{
                                            textTransform: "none",
                                            padding: 2,
                                            borderWidth: 1,
                                            borderRadius: "8px",
                                        }}
                                        disabled={isSavingMetric}
                                        // sx={{ padding: 2, borderRadius: "8px", ":disabled": { color: '#d9d9d9' } }}
                                        onClick={(e) => {
                                            // formik.resetForm();
                                            // handleFormSubmit(e, formik);
                                            // formik.setValues({ ...initialValues, month: savedMetricDataByID?.month });
                                            // navigate(-1);
                                            const hasChanges = hasFormChanges(formik?.values, isEditMode ? savedValues : initialValues)
                                            if (hasChanges) {
                                                setHasUnsavedChanges(true);
                                            } else {
                                                navigate(-1);
                                            }

                                        }}
                                        fullWidth
                                    >
                                        Close
                                    </Secondary>
                                </Grid>
                                <Grid xs={5} sm={5} md={4} lg={3} item>
                                    <Primary
                                        disabled={isSavingMetric}
                                        sx={{ padding: 2, borderRadius: "8px", ":disabled": { color: '#d9d9d9' } }}
                                        onClick={(e) => {
                                            // formik.handleSubmit();
                                            // console.log("working")
                                            handleFormSubmit(e, formik);
                                        }}
                                        fullWidth
                                    >
                                        {isSavingMetric ? <CircularProgress sx={{ color: "white", marginInline: 'auto' }} size="1.4rem" /> : "Submit"}
                                    </Primary>
                                </Grid>
                            </Grid>
                        </Grid>
                }
                {/* </PerfectScrollbar> */}
            </ThemeBGWrapper>
            {/* {console.log(formik.errors, "validations")} */}
        </>
    )
}

export default EditPerformance
